<template lang="pug">
.container.grid-lg.py-2
  load-manager(:status="status")
    div(v-if="current")
      section.top-header
        .text-bold {{ current.usuario ? current.usuario.nome : "" }}
        .columns
          item-col.col-auto(
            label="pontuacao_resumo.referencia",
            :value="current.referencia",
            value-class="text-bold"
          )
          item-col.col-auto(
            label="pontuacao_resumo.valor_total",
            :value="current.valor_total | currency",
            value-class="text-bold"
          )
          .column
          .column.col-auto
            a.btn.btn-link(:href="current.url", target="_blank")
              btn-content(name="print")
        .divider
      section
        .columns
          item-col.my-1.col-4.col-sm-12(
            label="pontuacao_resumo.individual_bruto",
            :value="current.individual_bruto | currency"
          )
          item-col.my-1.col-4.col-sm-12(
            label="pontuacao_resumo.perdidos",
            :value="current.perdidos | currency"
          )
          item-col.my-1.col-4.col-sm-12(
            label="pontuacao_resumo.individual_total",
            :value="current.individual_total | currency"
          )
          item-col.my-1.col-4.col-sm-12(
            label="pontuacao_resumo.individual_liquido",
            :value="current.individual_liquido | currency"
          )
          item-col.my-1.col-4.col-sm-12(
            label="pontuacao_resumo.extraordinario",
            :value="current.extraordinario | currency"
          )
          item-col.my-1.col-4.col-sm-12(
            label="pontuacao_resumo.coletivo",
            :value="current.coletivo | currency"
          )
          item-col.my-1.col-4.col-sm-12(
            label="pontuacao_resumo.total",
            :value="current.total | currency"
          )
          item-col.my-1.col-4.col-sm-12(
            label="pontuacao_resumo.dias_afastado",
            :value="current.dias_afastado"
          )
          item-col.my-1.col-4.col-sm-12(
            label="pontuacao_resumo.dias_uteis_afastado",
            :value="current.dias_uteis_afastado"
          )
          item-col.my-1.col-4.col-sm-12(
            label="pontuacao_resumo.em_experiencia",
            :value="current.em_experiencia ? 'Sim' : 'Não'"
          )
          item-col.my-1.col-4.col-sm-12(
            label="pontuacao_resumo.encerrado",
            :value="current.encerrado ? 'Sim' : 'Não'"
          )
          item-col.my-1.col-4.col-sm-12(
            label="Usuário Interno",
            :value="current.interno ? 'Sim' : 'Não'"
          )
      section(v-if="current.pontuacoes")
        .divider.text-center(data-content="Pontuações")
        table.table.table-striped.table-hover.table-sm
          thead
            tr
              th {{ "pontuacao.tipo" | tModel }}
              th {{ "pontuacao.pontos" | tModel }}
              th {{ "pontuacao.observacao" | tModel }}
              th
          tbody
            tr(v-for="row in current.pontuacoes", :key="row.id")
              td {{ row | enums("pontuacao.tipo") }}
              td {{ row.pontos }}
              td {{ row.observacao }}
              td
                span(v-if="row.ordem_servico")
                  router-link.tooltip.tooltip-left(
                    data-tooltip="Ver OS-m",
                    :to="{ name: 'app.osm.servicos.show', params: { id: row.ordem_servico.id } }"
                  )
                    span {{ `${row.ordem_servico.numero}/${row.ordem_servico.ano}` }}
                span(v-else-if="row.doc")
                  router-link.tooltip.tooltip-left(
                    data-tooltip="Ver Documento",
                    :to="{ name: 'fiscalizacao.docs.show', params: { id: row.doc.id } }"
                  )
                    span {{ `${row.doc.numero}/${row.doc.ano}` }}
                btn-logs.btn-sm(
                  entityName="Pontuacao",
                  :entityId="row.id",
                  v-acl:allowed.admin.logs.index
                )
      section(v-if="!current.encerrado")
        .py-2
          button.btn.btn-link(@click="showServicoExtra = true")
            btn-content(name="new", label="Incluir Serviços Extras")
          button.btn.btn-link(@click="showPontosAvulso = true")
            btn-content(name="new", label="Incluir Pontos Avulso")
          button.btn.btn-link(@click="showFalta = true")
            btn-content(name="new", label="Incluir Falta")
          router-link.btn.btn-link(
            :to="{ name: 'app.produtividade.geral.resumos.afastamentos', params: { id: current.usuario_id } }",
            v-acl:allowed.admin.produtividade.afastamentos.create,
            :disabled="!current.cargo"
          )
            btn-content(icon="fa fa-stop-circle-o", label="Afastamentos")
        servico-extra(
          :resumo="current",
          :active="showServicoExtra",
          @close="onCloseServicoExtra"
        )
        pontos-avulso(
          :resumo="current",
          :active="showPontosAvulso",
          @close="onClosePontosAvulso"
        )
        falta(:resumo="current", :active="showFalta", @close="onCloseFalta")
</template>

<script>
import ServicoExtra from "./pontuacoes/ServicoExtra"
import PontosAvulso from "./pontuacoes/PontosAvulso"
import Falta from "./pontuacoes/Falta"

export default {
  vuex: {
    "produtividade/resumos": {
      state: ["current", "status"],
      actions: ["fetchOne"],
    },
  },

  components: { ServicoExtra, PontosAvulso, Falta },

  computed: {
    resumoId() {
      return Number(this.$route.params.resumoId)
    },
  },

  data() {
    return {
      showServicoExtra: false,
      showPontosAvulso: false,
      showFalta: false,
    }
  },

  methods: {
    onCloseServicoExtra(response) {
      this.showServicoExtra = false
      if (response) {
        this.fetchOne(this.resumoId)
      }
    },

    onClosePontosAvulso(response) {
      this.showPontosAvulso = false
      if (response) {
        this.fetchOne(this.resumoId)
      }
    },

    onCloseFalta(response) {
      this.showFalta = false
      if (response) {
        this.fetchOne(this.resumoId)
      }
    },

    isFetchOne() {
      return !this.current || Number(this.current.id) !== this.resumoId
    },
  },

  mounted() {
    if (this.isFetchOne()) {
      this.fetchOne(this.resumoId)
    }
  },
}
</script>

<style lang="stylus" scoped>
.top-header {
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 1;
  padding-top: 5px;
}
</style>
